const state = {
  mvTranslate: false,
  mvRequest: false,
  mvResponse: false
}

const getters = {
  getMvTranslate: state => {
    return state.mvTranslate
  },
  getMvRequest: state => {
    return state.mvRequest
  },
  getMvResponse: state => {
    return state.mvResponse
  }
}

const mutations = {
  setMvTranslate: state => {
    state.mvTranslate = true
  },
  setMvRequest: state => {
    state.mvRequest = true
  },
  setMvResponse: state => {
    state.mvResponse = true
  }
}

const actions = {
  setMvTranslate: ({ commit }) => {
    commit('setMvTranslate')
  },
  setMvRequest: ({ commit }) => {
    commit('setMvRequest')
  },
  setMvResponse: ({ commit }) => {
    commit('setMvResponse')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
